import React from "react";

export default function CSS_Quiz() {
  return (
    <div className="tutorial-page">
      <h1>CSS Quiz</h1>
      <p>This is the CSS Quiz tutorial page.</p>
    </div>
  );
}
